export default "__VITE_ASSET__DnIpU_Wu__"